export default {
  clientId: '329989507288-b6017ej301uatn06fcov43jcnqdghbbj.apps.googleusercontent.com',
  scope: 'https://www.googleapis.com/auth/photoslibrary.readonly',
  prompt: 'consent',
  fetch_basic_profile: false
}
